import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http.service';
import { Endpoints } from '../../../../models/endpoints';
import { EformInfoService } from './eform-info.service';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { Avis } from '../../../../models/avis';
import { ENoticeTypeXsd } from '../../../../models/enums/enotice-type-xsd.enum';
import { EformsToolsService } from './e-forms-tools.service';
import { FormulaireServiceService } from '../../services/formulaire-service.service';
import { EformDuplicableFieldsService } from './eform-duplicable-fields.service';

@Injectable({
  providedIn: 'root'
})
export class EformPrefillService {

  codeOrigine: string;
  tempNotice;
  isPrefillAvisLie = false;
  noticeCompleted = new BehaviorSubject(null);

  constructor(
    private http: HttpService,
    private eformInfoService: EformInfoService,
    private eformsToolsService: EformsToolsService,
    private formulaireService: FormulaireServiceService,
    private eformDuplicableFieldsService: EformDuplicableFieldsService
  ) { }

  prefillAvisLieEform(modalite: number,origine: string,arrivee: string,referenceParent, noticeValueArrive){
    if(origine){
      // ✅ FIX 2026-01-23: Désactiver les conditions de visibilité pendant le chargement de l'avis lié
      // pour éviter la perte des champs conditionnés (Lieu d'exécution, BT-01(f), BT-09(b), Critères d'attribution)
      this.eformDuplicableFieldsService.setLoadingAvisLie(true);

      //Call back pour récupérer les fields à mapper
      combineLatest([
        this.http.post(Endpoints.MAPPINGAVISLIE,{ formOrigine: origine, formArrive: arrivee}),
        this.http.get(Endpoints.AVIS_FIND_BY_REFERENCE + referenceParent, Avis)
      ]).subscribe( results => {
        if(results){
          let mappingFields: string[] = results[0] as string[];
          let noticeValueOrigine=results[1];
          //On filtre car on va gérer le préremp des elements duplicable côté back
          mappingFields = mappingFields.filter(e=>!e.toLowerCase().includes('lot') && !e.toLowerCase().includes('tender') && !e.toLowerCase().includes('contract') && !e.toLowerCase().includes('organization'))


          //faire le préremp selon la modalité 1 vide, 2 existant
          switch(modalite) {
            case 1: {
              this.noticeCompleted.next(this.modaliteUneMapping(mappingFields,noticeValueOrigine,noticeValueArrive));
              break;
            };
            case 2: {
              this.noticeCompleted.next(this.modaliteDeuxMapping(mappingFields,noticeValueOrigine,noticeValueArrive));
              break;
            };
            default: break;
          }
          // ✅ FIX 2026-02-12: Ne plus désactiver isLoadingAvisLie ici.
          // La désactivation est maintenant gérée dans e-forms-generator.component.ts
          // APRÈS que le formulaire soit complètement rendu et stabilisé.
          // Cela évite la race condition où les conditions de visibilité sont évaluées
          // avant que les données ne soient complètement chargées dans le formulaire.
        }
      });
    }
  }

  /**
   * Remplissage modalité une
   * @param mappingFields les champs à remplir
   * @param noticeValueOrigine la notice d'origine
   * @param noticeValue la notice d'arrivée
   * @returns
   */
  modaliteUneMapping(mappingFields,noticeValueOrigine,noticeValue){
    let noticeValueOnWork = this.eformsToolsService.propertyNamesToLowercase(noticeValue);
    let noticeValueOrigineOnWork = this.eformsToolsService.propertyNamesToLowercase(noticeValueOrigine.jsonSaisieFormulaire.ann);
    let objectOnWork = noticeValueOnWork;

    mappingFields.forEach(fieldToFill => {
        let path = this.eformInfoService.mapFieldCurrentJsonForm.get(fieldToFill.toLowerCase());
        let splittedPath = path?.split('.');
        if(splittedPath){
          objectOnWork = this.fill(splittedPath,noticeValueOrigineOnWork,objectOnWork,0,'',ENoticeTypeXsd[noticeValueOrigine.formulaire.code].toLowerCase(),1, mappingFields);
        }
    });


    return objectOnWork;
  }

  modaliteDeuxMapping(mappingFields,noticeValueOrigine,noticeValue) {
    this.recupContractFolderId(noticeValueOrigine)
    this.recupIdParentFluxBoampEform(noticeValueOrigine)
    let noticeValueOnWork = this.eformsToolsService.propertyNamesToLowercase(noticeValue);
    let noticeValueOrigineOnWork = this.eformsToolsService.propertyNamesToLowercase(noticeValueOrigine.jsonSaisieFormulaire.ann);
    let objectOnWork = noticeValueOnWork;
    mappingFields.forEach(fieldToFill => {
        let path = this.eformInfoService.mapFieldCurrentJsonForm.get(fieldToFill.toLowerCase());
        if(path){
          let splittedPath = path?.split('.');
          if(this.goToField(path,noticeValueOrigineOnWork,ENoticeTypeXsd[noticeValueOrigine.formulaire.code].toLowerCase())){
            objectOnWork = this.fill(splittedPath,noticeValueOrigineOnWork,objectOnWork,0,'',ENoticeTypeXsd[noticeValueOrigine.formulaire.code].toLowerCase(),2, mappingFields);
          }
        }
    });
    return objectOnWork;
  }

  recupContractFolderId(noticeValueOrigine){
    let contractFolderId;
    if (noticeValueOrigine.jsonSaisieFormulaire.ann.priorInformationNotice){
      contractFolderId = noticeValueOrigine.jsonSaisieFormulaire.ann.priorInformationNotice.contractFolderID?.val
    }
    if (noticeValueOrigine.jsonSaisieFormulaire.ann.contractAwardNotice){
      contractFolderId = noticeValueOrigine.jsonSaisieFormulaire.ann.contractAwardNotice.contractFolderID?.val
    }
    if (noticeValueOrigine.jsonSaisieFormulaire.ann.contractNotice){
      contractFolderId = noticeValueOrigine.jsonSaisieFormulaire.ann.contractNotice.contractFolderID?.val
    }
    this.formulaireService.actualFormContractFolderId.next(contractFolderId);
  }

  recupIdParentFluxBoampEform(noticeValueOrigine){
    this.formulaireService.idParentFluxBoampEform.next(noticeValueOrigine.flux.filter(e=>e.fluxBoamp)[0].fluxBoamp?.idPublicationEForms);
  }

  /**
   * Utilise le jsonpath pour remplir le field correspondant
   * @param splittedPath le jsonpath split via "."
   * @param noticeValueOrigineOnWork la notice d'origine
   * @param objectOnWork la notice d'arrivée, sur laquelle on travaille
   * @param iteration iteration du splittedpath
   * @param actualPath le splittedpath actuel
   * @param formcode pour la notice d'origine, le type de form (prior,contract,business...)
   * @param modalite modalite en cours
   * @param mappingFields les champs à remplir
   * @returns la notice d'arrivée modifiée
   */
  fill(splittedPath,noticeValueOrigineOnWork,objectOnWork,iteration,actualPath,formcode,modalite, mappingFields){
    actualPath = splittedPath[iteration]?.replace('[]','');
    // Si on est à .val , on retourne l'objet (pour garder les schemenames, listnames etc...)
    if(splittedPath.findIndex(v => v==actualPath) == splittedPath.length-1){
      return this.fillSubObject(splittedPath,noticeValueOrigineOnWork,objectOnWork[actualPath],++iteration,actualPath,formcode,modalite, mappingFields);
    }
    if(iteration==0){
      noticeValueOrigineOnWork = noticeValueOrigineOnWork[formcode];
    } else if (noticeValueOrigineOnWork && actualPath){
      noticeValueOrigineOnWork = noticeValueOrigineOnWork[actualPath];
    }

    if(Array.isArray(noticeValueOrigineOnWork) || splittedPath[iteration]?.includes('[]')){
      if(objectOnWork[actualPath]){
        //objectOnWork = objectOnWork[actualPath];
      } else {
        objectOnWork[actualPath] = [];
        //objectOnWork = objectOnWork[actualPath];
      }
      noticeValueOrigineOnWork?.forEach((arrayValue,iterationArray) =>  {
        if(!objectOnWork[actualPath][iterationArray]){
          objectOnWork[actualPath][iterationArray] = {};
        }
        objectOnWork[actualPath][iterationArray] = this.fillSubObject(splittedPath,arrayValue,objectOnWork[actualPath][iterationArray],(iteration+1),actualPath,formcode,modalite, mappingFields);
      });
      if(modalite==2){
        objectOnWork[actualPath].length = noticeValueOrigineOnWork ? noticeValueOrigineOnWork.length : 0;
      }
      return objectOnWork;
    } else {
      if (actualPath) {
        if(objectOnWork && objectOnWork[actualPath]){
          objectOnWork[actualPath] =  this.fillSubObject(splittedPath,noticeValueOrigineOnWork,objectOnWork[actualPath],++iteration,actualPath,formcode,modalite, mappingFields);
          return objectOnWork;
        } else {
          objectOnWork[actualPath] = {};
          objectOnWork[actualPath] = this.fillSubObject(splittedPath,noticeValueOrigineOnWork,objectOnWork[actualPath],++iteration,actualPath,formcode,modalite, mappingFields);
          return objectOnWork;

        }
      } else if(!actualPath
        && noticeValueOrigineOnWork != null
          && noticeValueOrigineOnWork.inputid != null  // Ajout de la vérification sur l'inputid car quand on vient d'un avis importé, pas d'inputId
            && !mappingFields.includes(noticeValueOrigineOnWork.inputid)){
        objectOnWork = {};
        return objectOnWork;
      } else if(!actualPath
        && noticeValueOrigineOnWork != null
          && noticeValueOrigineOnWork.inputid != null // Ajout de la vérification sur l'inputid car quand on vient d'un avis importé, pas d'inputId
            && mappingFields.includes(noticeValueOrigineOnWork.inputid)){
        objectOnWork = noticeValueOrigineOnWork;
        return objectOnWork;
      } else {
        // Ajout de ce else pour gérer le cas de création d'un avis lié à partir d'un avis importé : pas d'inputid
        objectOnWork = noticeValueOrigineOnWork;
        return objectOnWork;
      }
    }
  };

  /**
   * Remplis l'objet enfant
   * @param splittedPath
   * @param noticeValueOrigineOnWork
   * @param objectOnWorkSub
   * @param iteration
   * @param actualPath
   * @param formcode pour la notice d'origine, le type de form (prior,contract,business...)
   * @param modalite modalite en cours
   * @param mappingFields les champs à remplir
   * @returns l'objet en cours modifié
   */
  fillSubObject(splittedPath,noticeValueOrigineOnWork,objectOnWorkSub,iteration,actualPath,formcode,modalite, mappingFields){
    return this.fill(splittedPath,noticeValueOrigineOnWork,objectOnWorkSub,iteration,actualPath,formcode,modalite, mappingFields)
  }


  /**
   *
   * @param value le jsonpath
   * @param noticeValueOrigine la notice d'origine
   * @returns la valeur du jsonpath, si trouvée
   */
  goToField(value,noticeValueOrigine,formcode){
    let path = value.replace(value.split('/')[0],formcode);
		return JSON.parse(JSON.stringify(path)).toLowerCase().split('/').reduce((p, q) => {
			if(p == null || p == undefined){
				return null;
			}
			let temp = null;
			if(q.includes("[")){
				temp = p[q.replace("[]","")];
        if(temp){
          temp = temp[0];
        }
      } else {
				temp = p[q];
      }
      return temp;
		} , noticeValueOrigine);
	}

}
